/*
 * Copyright (c) 2022
 * 
 * Created Date: Friday, September 30th 2022, 3:20:53 pm
 * Author: Muhammad Fajariansyah Ismail
 * 
 */

import IconConfirmSuccess from "assets/icons/IconConfirmSuccess"
import JoinRoomAlert from "components/Alert/JoinRoomAlert"
import OpenBrowser from "components/Alert/OpenBrowser"
import LunaAlertContent from "components/Alert/LunaAlertContent"
import ScanQRCode from "components/Alert/ScanQRCode"
import SendingAttendanceAlert from "components/Alert/SendingAttendanceAlert"
import Swal from "sweetalert2"
import withReactContent from 'sweetalert2-react-content'
import i18n from 'i18n';
import IconWarning from "assets/icons/IconWarning"

const ReactSwal = withReactContent(Swal)

/**
 * 
 * @param {LunaAlertParamProp} lunaAlertParam
 */
const success = (lunaAlertParam) => {
    const { title, description, confirmButtonText, onConfirmButton, swalOptions = {}, icon = <IconConfirmSuccess />, } = lunaAlertParam
    ReactSwal.fire({
        html: <LunaAlertContent 
            title={title} 
            description={description} 
            icon={icon} 
            confirmButtonText={confirmButtonText} 
            onConfirmButtonClicked={onConfirmButton} />,
        showConfirmButton: false,
        ...swalOptions
    })
}


/**
 * 
 * @param {LunaAlertParamProp} lunaAlertParam
 */
const error = (lunaAlertParam) => {
    const { title, description, confirmButtonText, onConfirmButton, swalOptions = {}, icon = undefined } = lunaAlertParam
    return ReactSwal.fire({
        customClass: {
            container: "luna-alert alert-error",
        },
        html: <LunaAlertContent title={title}
            description={description}
            icon={icon}
            confirmButtonText={confirmButtonText}
            onConfirmButtonClicked={onConfirmButton}
            type="error" />,
        showConfirmButton: false,
        ...swalOptions
    })
}

/**
 * 
 * @param {LunaAlertParamProp} lunaAlertParam
 */
const confirm = (lunaAlertParam) => {
    const {
        title,
        description,
        confirmButtonText,
        cancelButtonText,
        onConfirmButton,
        icon = undefined,
        type = "primary",
        swalOptions = {} } = lunaAlertParam

    ReactSwal.fire({
        customClass: {
            container: "luna-alert alert-confirm",
        },
        html: <LunaAlertContent title={title}
            description={description}
            icon={icon}
            showCancelButton={true}
            confirmButtonText={confirmButtonText}
            cancelButtonText={cancelButtonText}
            onConfirmButtonClicked={onConfirmButton}
            type={type} />,
        showConfirmButton: false,
        ...swalOptions
    })
}

/**
 * 
 * @param {String} url 
 * @param {SweetAlertOptions} swalOptions 
 */
const joinRoomDialog = (url, swalOptions) => {
    ReactSwal.fire({
        html: <JoinRoomAlert url={url}/>,
        showConfirmButton: false,
        ...swalOptions
    })
}

/**
 * @param {Function} onQRScanned
 * @param {SweetAlertOptions} swalOptions 
 */
const scanQRCode = (onQRScanned, swalOptions) => {
    ReactSwal.fire({
        html: <ScanQRCode onQRScanned={onQRScanned}/>,
        showConfirmButton: false,
        ...swalOptions
    })
}

const recordAttendanceAlert = () => {
    ReactSwal.fire({
        html: <SendingAttendanceAlert/>,
        showConfirmButton: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        showCloseButton: false,
        allowOutsideClick: false
    })
}

const openInBrowserDialog = (url, swalOptions) => {
    ReactSwal.fire({
        html: <OpenBrowser url={url}/>,
        showConfirmButton: false,
        ...swalOptions
    })
}

const showComingSoonFeatureAlert = (params={}) => {

    const {t} = i18n
  
    ReactSwal.fire({
        customClass: {
            container: "luna-alert alert-primary",
        },
        html: <LunaAlertContent
            icon={<IconWarning color="#4E4602" />}
            type="warning"
            title={t('globalAlert.comingSoon.title')}
            description={t('globalAlert.comingSoon.description')}
            confirmButtonText='Ok' />,
        showConfirmButton: false,
    })
}

  
const LunaAlert = {
    success,
    confirm,
    error,
    joinRoomDialog,
    scanQRCode,
    recordAttendanceAlert,
    openInBrowserDialog,
    showComingSoonFeatureAlert
}

export default LunaAlert
